import { useState, useEffect } from 'react';

/**
 * Hook personnalisé pour détecter les media queries
 * @param {string} query - La media query à écouter (ex: '(min-width: 1024px)')
 * @returns {boolean} - true si la media query correspond
 */
const useMediaQuery = (query) => {
  const [matches, setMatches] = useState(false);

  useEffect(() => {
    const media = window.matchMedia(query);

    // Mettre à jour l'état initial
    if (media.matches !== matches) {
      setMatches(media.matches);
    }

    // Créer un listener pour les changements
    const listener = (e) => setMatches(e.matches);

    // Utiliser addEventListener pour une meilleure compatibilité
    media.addEventListener('change', listener);

    // Cleanup
    return () => media.removeEventListener('change', listener);
  }, [matches, query]);

  return matches;
};

export default useMediaQuery;
